import React from 'react';
import { Button } from './ui/Button';
export function PricingCTA() {
  return <section id="pricing" className="py-8 px-4 bg-cream" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        {/* Urgency Table */}
        <div className="mb-10" data-id="element-107">
          <h2 className="text-xl md:text-2xl font-bold text-center mb-6 flex items-center justify-center gap-2" data-id="element-108">
            <span data-id="element-109">⚡</span> Esta oferta con los 4 Bonos es por tiempo limitado
          </h2>

          <div className="bg-white rounded-2xl shadow-soft overflow-hidden" data-id="element-110">
            <table className="w-full text-center" data-id="element-111">
              <thead data-id="element-112">
                <tr data-id="element-113">
                  <th className="py-3 px-3 bg-deep-rose text-white w-1/2 text-base font-bold" data-id="element-114">
                    Si comprás HOY
                  </th>
                  <th className="py-3 px-3 bg-warm-brown text-white w-1/2 text-base font-bold" data-id="element-115">
                    Si esperás
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-soft-rose" data-id="element-116">
                <tr data-id="element-117">
                  <td className="py-3 px-3 bg-soft-rose/20 text-sm" data-id="element-118">
                    ✅ 2 Tomos completos
                  </td>
                  <td className="py-3 px-3 text-sm" data-id="element-119">✅ 2 Tomos completos</td>
                </tr>
                <tr data-id="element-120">
                  <td className="py-3 px-3 bg-soft-rose/20 font-bold text-deep-rose text-sm" data-id="element-121">
                    ✅ 4 Bonos incluidos GRATIS
                  </td>
                  <td className="py-3 px-3 text-warm-brown/50 text-sm" data-id="element-122">
                    ❌ Sin bonos
                  </td>
                </tr>
                <tr data-id="element-123">
                  <td className="py-3 px-3 bg-soft-rose/20 font-bold text-deep-rose text-sm" data-id="element-124">
                    ✅ Precio de lanzamiento $19.999
                  </td>
                  <td className="py-3 px-3 text-warm-brown/50 text-sm" data-id="element-125">
                    ❌ Precio regular $45.000
                  </td>
                </tr>
                <tr data-id="element-126">
                  <td className="py-3 px-3 bg-soft-rose/20 text-sm" data-id="element-127">
                    ✅ Garantía 7 días
                  </td>
                  <td className="py-3 px-3 text-sm" data-id="element-128">✅ Garantía 7 días</td>
                </tr>
                <tr data-id="element-129">
                  <td className="py-3 px-3 bg-soft-rose/20 text-sm" data-id="element-130">
                    ✅ Acceso inmediato
                  </td>
                  <td className="py-3 px-3 text-sm" data-id="element-131">✅ Acceso inmediato</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mt-6 space-y-3" data-id="element-132">
            <h3 className="text-xl font-bold text-warm-brown-dark" data-id="element-133">
              No necesitás "pensar más". Ya lo estás sintiendo.
            </h3>
            <p className="text-base text-warm-brown" data-id="element-134">
              Esa sensación en el pecho que tenés ahora mismo mientras leés esto
              es tu linaje diciéndote:
            </p>
            <p className="text-2xl font-bold text-deep-rose italic" data-id="element-135">
              "Es hora."
            </p>
          </div>
        </div>

        {/* Main CTA Box */}
        <div id="pricing-cta-button" className="bg-white rounded-3xl shadow-glow p-6 md:p-8 border-2 border-deep-rose/30 text-center" data-id="element-136">
          <h2 className="text-2xl font-bold mb-6" data-id="element-137">Todo lo que recibís hoy:</h2>

          <div className="space-y-2 text-base mb-6 text-left max-w-md mx-auto" data-id="element-138">
            <p className="flex justify-between" data-id="element-139">
              <span data-id="element-140">📖 Tomo 1: El Despertar del Útero</span>{' '}
              <span data-id="element-141">$45.000</span>
            </p>
            <p className="flex justify-between" data-id="element-142">
              <span data-id="element-143">📖 Tomo 2: El Templo de los Corazones</span>{' '}
              <span data-id="element-144">$45.000</span>
            </p>
            <p className="flex justify-between" data-id="element-145">
              <span data-id="element-146">🎁 Bono 1: Kit Express Mamá</span> <span data-id="element-147">$25.000</span>
            </p>
            <p className="flex justify-between" data-id="element-148">
              <span data-id="element-149">🎁 Bono 2: Workbook Mapa del Linaje</span>{' '}
              <span data-id="element-150">$25.000</span>
            </p>
            <p className="flex justify-between" data-id="element-151">
              <span data-id="element-152">🎁 Bono 3: Ritual Seguro en Casa</span> <span data-id="element-153">$20.000</span>
            </p>
            <p className="flex justify-between" data-id="element-154">
              <span data-id="element-155">🎁 Bono 4: Pack Mantras en Tarjetas</span>{' '}
              <span data-id="element-156">$20.000</span>
            </p>
            <div className="border-t border-soft-rose pt-2 mt-2" data-id="element-157">
              <p className="flex justify-between text-warm-brown/60 line-through font-bold text-sm" data-id="element-158">
                <span data-id="element-159">VALOR TOTAL</span> <span data-id="element-160">$180.000</span>
              </p>
              <p className="flex justify-between text-xl font-bold text-deep-rose mt-2" data-id="element-161">
                <span data-id="element-162">🔥 TU INVERSIÓN HOY</span> <span data-id="element-163">$19.999</span>
              </p>
            </div>
          </div>

          <Button onClick={() => window.open('https://pagos.indigo33.shop/cart/43934466932824:1', '_blank')} className="text-lg px-6 py-4 w-full md:w-auto mb-4" data-id="element-164">
            🌹 SÍ, QUIERO SANAR MI LINAJE HOY
          </Button>
          <p className="text-base font-medium text-warm-brown mb-6" data-id="element-165">
            Accedo ahora a los 2 Tomos + 4 Bonos por solo $19.999
          </p>

          {/* Payment Methods */}
          <div className="border-t border-soft-rose pt-6 mb-6" data-id="element-166">
            <h4 className="text-xs font-bold text-warm-brown uppercase tracking-wider mb-3" data-id="element-167">
              💳 FORMAS DE PAGO
            </h4>
            <div className="flex flex-wrap justify-center text-xs text-warm-brown-dark gap-[9px]" data-id="element-168">
              <span className="bg-soft-rose px-3 py-1 rounded-full" data-id="element-169">
                ✅ Tarjeta de Crédito (Visa, Mastercard, Amex)
              </span>
              <span className="bg-soft-rose px-3 py-1 rounded-full" data-id="element-170">
                ✅ Tarjeta de Débito
              </span>
              <span className="bg-soft-rose px-3 py-1 rounded-full" data-id="element-171">
                ✅ Mercado Pago
              </span>
              <span className="bg-soft-rose px-3 py-1 rounded-full" data-id="element-172">
                ✅ Transferencia
              </span>
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-cream rounded-2xl p-4 text-left" data-id="element-173">
            <h4 className="font-bold text-base mb-3 text-center" data-id="element-174">
              ¿Qué pasa después de que hacés clic?
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-175">
              <li className="flex gap-3" data-id="element-176">
                <span className="text-deep-rose" data-id="element-177">🔐 Paso 1:</span> Llegás a una
                página de pago 100% segura.
              </li>
              <li className="flex gap-3" data-id="element-178">
                <span className="text-deep-rose" data-id="element-179">📩 Paso 2:</span> Recibís un
                email con acceso inmediato a tu cuenta.
              </li>
              <li className="flex gap-3" data-id="element-180">
                <span className="text-deep-rose" data-id="element-181">📖 Paso 3:</span> Descargás los
                2 Tomos y los 4 Bonos al instante.
              </li>
              <li className="flex gap-3 font-bold" data-id="element-182">
                <span className="text-deep-rose" data-id="element-183">🌹 Paso 4:</span> Empezás tu
                proceso esta misma noche.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}